import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  private appConfig: any;
  private http: HttpClient;

  constructor(private readonly httpHandler: HttpBackend) {
    this.http = new HttpClient(httpHandler);
  }

  loadAppConfig(configUrl: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.http.get(configUrl)
        .pipe(map(res => res))
        .subscribe(data => {

          this.appConfig = data;
          resolve(true);
        },
          (error) => {
            reject(error);
          });
    });
  }


  appConfigAvailable(): boolean {
    return this.appConfig != null;
  }

  get(key?: string | Array<string>): any {

    if (!key || (Array.isArray(key) && !key[0])) {
      return this.appConfig;
    }

    if (!Array.isArray(key)) {
      key = key.split('.');
    }

    const result = key.reduce((acc: any, current: string) => acc && acc[current], this.appConfig);
    return result;
  }
}

